<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import PositionForm from '../../../components/settings/position/Form';
import ErrorDialog  from '../../../components/common/ErrorDialog';

export default {
  components: {
    'app-form':  PositionForm,
    'app-error': ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupposition.newposition'),
      formData: {
        id:         null,
        positionid: null,
        poscode:    null,
        posdesc:    null,
        isdisable:  false,
        remark:     null,
        startdate:  null,
        enddate:    null,
        positioncount:      null,
        repposid:   null,
        compnyid:   null,
        brchid:     null,
        divnid:     null,
        deptid:     null,
        sectioid:   null,
        unitid:     null,
        jobid:      null,
        grdid:      null,
        emptypeid:  null,
        stamp:      0,
        userid:     this.$store.getters.userId,
      },
      errMsg:   '',
      isErr:    false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr  = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, 'canadd')) {
        return false;
      }

      // Parent is created first (either via the inline + dialog or by selecting an
      // existing one). By save time positionid is always set — post only the child detail.
      const payload = {
        positionid: this.formData.positionid,
        startdate:  this.formData.startdate,
        enddate:    this.formData.enddate,
        count:      this.formData.positioncount,
        repposid:   this.formData.repposid,
        compnyid:   this.formData.compnyid,
        brchid:     this.formData.brchid,
        divnid:     this.formData.divnid,
        deptid:     this.formData.deptid,
        sectioid:   this.formData.sectioid,
        unitid:     this.formData.unitid,
        jobid:      this.formData.jobid,
        grdid:      this.formData.grdid,
        emptypeid:  this.formData.emptypeid,
        stamp:      this.formData.stamp,
        userid:     this.formData.userid,
      };

      this.$store.dispatch('post', { url: '/position/detail/create', payload })
        .then(res => {
          if (res.data.error) {
            vm.isErr  = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: 'positionlist' });
          }
        })
        .catch(err => {
          vm.isErr  = true;
          vm.errMsg = err;
        });
    },
  },
};
</script>
